import { useSearchParams } from 'react-router-dom';

const HIDE_NAV_PARAM = 'hideNav';

const EMBED_URL_PARAMS = [HIDE_NAV_PARAM] as const;

// Copy any embed params present in `from` onto `to`
export const carryOverEmbedParams = (
  from: URLSearchParams,
  to: URLSearchParams
): URLSearchParams => {
  for (const key of EMBED_URL_PARAMS) {
    const value = from.get(key);
    if (value !== null) to.set(key, value);
  }
  return to;
};

export const useHideNav = (): boolean => {
  const [searchParams] = useSearchParams();
  return searchParams.get(HIDE_NAV_PARAM) === 'true';
};
